import { render, staticRenderFns } from "./SystemDiagramRegisterDialog.vue?vue&type=template&id=ec40d344&"
import script from "./SystemDiagramRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./SystemDiagramRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports